var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgName(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M9 16.5C13.1421 16.5 16.5 13.1421 16.5 9C16.5 4.85786 13.1421 1.5 9 1.5C4.85786 1.5 1.5 4.85786 1.5 9C1.5 13.1421 4.85786 16.5 9 16.5Z",
    fill: "#BBBBBB"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9.00002 10.4549C10.574 10.4549 11.85 9.17889 11.85 7.60488C11.85 6.03087 10.574 4.75488 9.00002 4.75488C7.42601 4.75488 6.15002 6.03087 6.15002 7.60488C6.15002 9.17889 7.42601 10.4549 9.00002 10.4549Z",
    fill: "#BBBBBB"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M9 16.5C10.7893 16.502 12.5196 15.8605 13.875 14.6925C13.5236 13.6794 12.8653 12.801 11.9916 12.1794C11.1179 11.5577 10.0723 11.2236 9 11.2236C7.92772 11.2236 6.88208 11.5577 6.0084 12.1794C5.13473 12.801 4.47643 13.6794 4.125 14.6925C5.48044 15.8605 7.21075 16.502 9 16.5Z",
    fill: "#BBBBBB"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgName);
export default __webpack_public_path__ + "static/media/name.0ab5b06840227a50fbd66146fe863c77.svg";
export { ForwardRef as ReactComponent };